import React from "react";
import { Link } from "react-router-dom";
import { FaPaperPlane } from "react-icons/fa";
import { Translate, I18n } from "react-redux-i18n";
import { getKindCommerceLabel } from "./ProductCard";

class FaqCard extends React.Component {
  state = {
    answer: "",
  };

  onChangeAnswer = (event) => {
    this.setState({ answer: event.target.value });
  };

  onSubmitAnswer = (event) => {
    event.preventDefault();
    if (!this.state.answer.trim()) return;
    this.props.onReply(this.state.answer.trim());
    this.setState({ answer: "" });
  };

  render() {
    const { item, onAdClick, showReplyForm } = this.props;
    const isAnswered = item.Answer && item.Answer.length > 0;
    const kindCommerce = getKindCommerceLabel(item.KindCommerceId);

    return (
      <article className="faq-card">
        <div className="faq-card__media">
          <Link
            to={`/goder/show/${item.AdId}`}
            onClick={onAdClick}
            className="faq-card__media-link"
          >
            <img
              className="faq-card__img"
              src={item.Photo}
              alt={item.Name || "Product"}
            />
            {kindCommerce && (
              <span className="faq-card__kind">
                {kindCommerce}
              </span>
            )}
            <span
              className={`faq-card__status ${
                isAnswered ? "faq-card__status--closed" : "faq-card__status--pending"
              }`}
            >
              {isAnswered ? (
                <Translate value="faq_close" />
              ) : (
                <Translate value="faq_pending" />
              )}
            </span>
          </Link>
        </div>

        <div className="faq-card__body">
          <h3 className="faq-card__title">
            <Link to={`/goder/show/${item.AdId}`} onClick={onAdClick}>
              {item.Name}
            </Link>
          </h3>

          <dl className="faq-card__meta-row">
            <dt>
              <Translate value="faq_date" />
            </dt>
            <dd>{item.CreatedAt}</dd>
          </dl>

          <div className="faq-card__block">
            <span className="faq-card__label">
              <Translate value="faq_question" />
            </span>
            <p className="faq-card__text">{item.Question}</p>
          </div>

          {isAnswered && (
            <div className="faq-card__block faq-card__block--answer">
              <span className="faq-card__label">
                <Translate value="faq_answer" />
              </span>
              <p className="faq-card__text">{item.Answer}</p>
            </div>
          )}

          {showReplyForm && !isAnswered && (
            <form className="faq-card__reply" onSubmit={this.onSubmitAnswer}>
              <textarea
                name="answer"
                className="faq-card__reply-input form-control"
                placeholder={I18n.t("faq_reply")}
                value={this.state.answer}
                onChange={this.onChangeAnswer}
                rows={3}
              />
              <button
                type="submit"
                className="faq-card__reply-btn"
                disabled={!this.state.answer.trim()}
                aria-label={I18n.t("faq_reply")}
              >
                <FaPaperPlane />
                <span>
                  <Translate value="faq_reply" />
                </span>
              </button>
            </form>
          )}
        </div>
      </article>
    );
  }
}

export default FaqCard;
